var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.1vw",
    height: "1.1vw",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4989 13.2377V17.3077C17.4987 17.8836 17.2698 18.4358 16.8626 18.843C16.4554 19.2502 15.9032 19.479 15.3274 19.4793H4.69311C4.40688 19.4792 4.1235 19.4225 3.85925 19.3125C3.59499 19.2025 3.35508 19.0414 3.15328 18.8384C2.95149 18.6355 2.79179 18.3946 2.68337 18.1297C2.57496 17.8648 2.51995 17.5811 2.52152 17.2949V6.67254C2.51982 6.38677 2.57485 6.1035 2.68343 5.83915C2.792 5.5748 2.95196 5.33463 3.15404 5.13255C3.35611 4.93048 3.59628 4.77052 3.86063 4.66194C4.12498 4.55337 4.40825 4.49834 4.69402 4.50004H8.76311",
    stroke: "#50C878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4994 8.24573L13.7548 4.50023M6.26563 14.4864V12.5018C6.26746 12.1746 6.39763 11.8601 6.62771 11.6282L15.3654 2.89057C15.4813 2.77333 15.6194 2.68026 15.7715 2.61674C15.9237 2.55321 16.0869 2.52051 16.2518 2.52051C16.4167 2.52051 16.5799 2.55321 16.7321 2.61674C16.8842 2.68026 17.0223 2.77333 17.1382 2.89057L19.11 4.86232C19.2272 4.97825 19.3203 5.1163 19.3838 5.26845C19.4473 5.42061 19.48 5.58385 19.48 5.74873C19.48 5.91361 19.4473 6.07686 19.3838 6.22901C19.3203 6.38117 19.2272 6.51921 19.11 6.63515L10.3723 15.3728C10.14 15.6036 9.82616 15.7336 9.49871 15.7349H7.51413C7.3501 15.7351 7.18764 15.703 7.03606 15.6404C6.88448 15.5777 6.74675 15.4857 6.63076 15.3698C6.51478 15.2538 6.42283 15.116 6.36017 14.9645C6.29751 14.8129 6.26538 14.6504 6.26563 14.4864Z",
    stroke: "#50C878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.aa71d6cc7b69eed41b44cb8b94f35ffd.svg";
export { ForwardRef as ReactComponent };